import React from 'react';
import emptyDayIllustration from 'assets/images/agenda-mobile-empty-day.svg';
import { MobileAgendaEmptyDayMessage, MobileAgendaEmptyDayRoot } from '../styled';

export const AgendaMobileDayEmptyState: React.FC = () => {
  return (
    <MobileAgendaEmptyDayRoot role="status" aria-live="polite">
      <img src={emptyDayIllustration} alt="" width={114} height={88} decoding="async" />
      <MobileAgendaEmptyDayMessage>Sem atividades nesta data.</MobileAgendaEmptyDayMessage>
    </MobileAgendaEmptyDayRoot>
  );
};
